module.exports = __webpack_public_path__ + "6c7f7e115696c6a1b4c0a08a89b95a1f.jpg";